import { render, staticRenderFns } from "./popup-mono-text.vue?vue&type=template&id=e9039d22"
import script from "./popup-mono-text.vue?vue&type=script&lang=js"
export * from "./popup-mono-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports